import * as React from "react";
function SvgDashboardChart(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <path d="M12 21h16M14 12v8M17 12v8M20 16v4M23 12v8M26 16v4" />
        <rect x={1} y={1} width={30} height={30} rx={1} ry={1} />
        <path d="M1 7h30M9 7v24M12 25h2M16 25h5M23 25h5" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDashboardChart);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
